/* global KTUtil, KTImageInput, jQuery, Cropper */

let imageCount = 0;

export default class AvatarImageUpload {
  static selectorString() {
    return '.AvatarImageUpload';
  }

  render(node, props) {
    if (props.editable) {
      KTUtil.ready(() => {
        const imageId = `settings-sidebar-image-${imageCount++}`;
        node.setAttribute('id', imageId);

        // eslint-disable-next-line no-new
        new KTImageInput(imageId);
      });

      if (props.croppable) {
        this.cropImage = this.cropImage.bind(this);

        this.cropper = null;

        this.modal = node.querySelector('.modal');
        this.imageCropperWrapperContainer = node.querySelector('.image-cropper-wrapper-container');
        this.imageInputWrapper = node.querySelector('.image-input-wrapper');
        this.cropImageButton = node.querySelector('.modal .crop-image-button');
        this.cropImageButton.addEventListener('click', this.cropImage);
        this.croppedImageDataInput = node.querySelector('.cropped-image-data-input');
        this.fileInput = node.querySelector('input[type="file"]');
        this.fileInput.addEventListener('change', this.fileSelected.bind(this));
      }
    }
  }

  fileSelected(event) {
    if (!event.currentTarget.files[0]) {
      return;
    }

    const reader = new FileReader();
    reader.onload = e => {
      this.initCropper(e.target.result);
    };

    reader.readAsDataURL(event.currentTarget.files[0]);
  }

  initCropper(dataUrl) {
    // destroy old cropper if exists
    if (this.cropper) {
      this.cropper.destroy();
    }

    while (this.imageCropperWrapperContainer.childNodes.length > 0) {
      this.imageCropperWrapperContainer.removeChild(this.imageCropperWrapperContainer.firstChild);
    }

    const imageCropperWrapper = document.createElement('div');
    imageCropperWrapper.classList.add('image-cropper-wrapper');
    this.imageCropperWrapperContainer.appendChild(imageCropperWrapper);

    const image = document.createElement('img');
    image.style.display = 'none';
    image.src = dataUrl;

    imageCropperWrapper.appendChild(image);

    jQuery(this.modal).modal('show');

    setTimeout(() => {
      this.cropper = new Cropper(image, {
        aspectRatio: 1,
        autoCropArea: 1,
        viewMode: 1,
        dragMode: 'none',
        preview: `#${this.node.getAttribute('id')} .image-input-wrapper`,
        modal: true,
        highlight: false,
        background: false,
        movable: false,
        rotatable: false,
        scalable: false,
        zoomable: false,
        zoomOnTouch: false,
        zoomOnWheel: false,
        toggleDragModeOnDblclick: false,
      });
    }, 500);
  }

  cropImage() {
    if (this.cropper) {
      const dataUrl = this.cropper
        .getCroppedCanvas({
          imageSmoothingEnabled: true,
          imageSmoothingQuality: 'medium',
        })
        .toDataURL();

      this.imageInputWrapper.style.backgroundImage = `url(${dataUrl})`;

      while (this.imageInputWrapper.childNodes.length > 0) {
        this.imageInputWrapper.removeChild(this.imageInputWrapper.firstChild);
      }

      jQuery(this.modal).modal('hide');

      this.croppedImageDataInput.value = dataUrl;
    }
  }
}
